import { render, staticRenderFns } from "./Appraise.vue?vue&type=template&id=96d22584&"
import script from "./Appraise.vue?vue&type=script&lang=js&"
export * from "./Appraise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports